// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder';
import { OnboardingNudgeErrorBoundary } from '../onboarding-nudge-error-boundary';
import type { InstrumentedNudgeSpotlightCardType } from './types';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyInstrumentedNudgeSpotlightCard = lazyAfterPaint<InstrumentedNudgeSpotlightCardType>(
	() =>
		import(
			/* webpackChunkName: "async-software-instrumented-nudge-spotlight-card" */ './main'
		).then((exportedModule) => exportedModule.InstrumentedNudgeSpotlightCard),
	{
		ssr: false,
	},
);

/**
 * @deprecated Please use the PortalledNudge instead for faster/safer dev, for more details see https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */
export const InstrumentedNudgeSpotlightCard = ({
	children = null,
	...props
}: JSX.LibraryManagedAttributes<
	InstrumentedNudgeSpotlightCardType,
	ComponentProps<InstrumentedNudgeSpotlightCardType>
>) => (
	<OnboardingNudgeErrorBoundary
		id="instrumentedNudgeSpotlightCard"
		fallback={children}
		attributes={{ nudgeId: props.nudgeId }}
	>
		<Placeholder name="lazy-instrumented-nudge-spotlight-card" fallback={children}>
			<LazyInstrumentedNudgeSpotlightCard {...props}>{children}</LazyInstrumentedNudgeSpotlightCard>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);
